module.exports = {
  production: false,
  api: "https://localhost:8080/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_BEEbU5nJ2",
    userPoolWebClientId: "62i17rtkeip3indirte8qdn730",
  },
};
